import Heading from '../../shared/utils/Heading'
import { Box, Grid2, Typography } from '@mui/material'
import { Page_Padding } from '../../shared/constants'
import { EducationForLifeImages } from '../../assets/img/educationforlife/EducationForLifeImages'
import ScrollContainer from '../../shared/components/ScrollContainer'
import CustomDivider from '../../shared/utils/CustomDivider'
import { getImageUrl } from '../../shared/utils/getImageUrl'



const HeroSection = ({ heroData,bottomData }) => {
    return (
        <Box >
            <Box px={Page_Padding} sx={{ width: { xs: "90%", sm: "90%", md: "70%" }, mx: "auto", textAlign: "center" }}>
                <Heading Heading={heroData?.subheading} SubHeading={heroData?.heading} center />

                <Typography variant="h7" color='grey.400' mb={3} textAlign={"center"} fontWeight={300} dangerouslySetInnerHTML={{ __html: heroData?.description }} />
                {/* ELYF (Education for Life) is a structured, age-appropriate learning curriculum designed to ensure that every child masters the essential basics required for their grade level. Our philosophy is simple.Strong foundations create confident learners
                </Typography> */}

            </Box>
            <Box sx={{ position: "relative", p: 0 }}>
                <Box component={"img"} src={EducationForLifeImages.TopHeroCurve} sx={{ position: "absolute", left: 0, right: 0, top: -1, width: "100%", zIndex: 11, borderRadius: 0 }} />
                <Grid2 container spacing={"0rem"} sx={{ position: "relative", zIndex: 10, m: 0 }}>

                    <ScrollContainer itemSize={{ xs: 8, sm: 6, md: 6 }} >
                        {
                            heroData?.ImageList?.map((item, index) => (
                                <Box
                                    key={index}
                                    component={"img"}
                                    src={getImageUrl(item?.imageUrl)}
                                    sx={{
                                        width: "100%", height: { xs: 250, sm: 400, md: 500 },
                                        objectFit: "cover",
                                        borderRadius: 0
                                    }} />
                            ))}
                    </ScrollContainer>

                </Grid2>
                <Box component={"img"} src={EducationForLifeImages.BottomHeroCurve} sx={{ position: "absolute", bottom: -1, left: 0, right: 0, width: "100%", zIndex: 11, borderRadius: 0 }} />
            </Box>
            <Box px={Page_Padding} sx={{ width: { xs: "90%", sm: "90%", md: "80%" }, mx: "auto", textAlign: "center" }}>
                <Typography variant="h7" mb={3} textAlign={"center"} dangerouslySetInnerHTML={{ __html:bottomData?.description }} />
                    {/* Whether it is mathematics, reading, writing, logical thinking, or life skills
                    ELYF breaks down each concept into clear, easy to understand steps that help children build a strong academic base. Instead of rushing through textbook chapters, our curriculum focuses on what a child must truly know at that age so they can progress smoothly in school and beyond
                </Typography> */}
                <CustomDivider />

            </Box>





        </Box>
    )
}

export default HeroSection
